import React, { useState } from "react";
import { observer } from "mobx-react";
import { useStore } from "../../../store";
import {
  SelectChangeEvent,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Checkbox,
  DialogContentText,
} from "@mui/material";
import Select, { SelectProps } from "../../../components/Select";
import SelectRationg, {
  SelectRatingProps,
} from "../../../components/SelectRating";
import Search, { SearchProps } from "../../../components/Search";
import { TextField, Autocomplete } from "@mui/material";
import {
  Container,
  SecondContainer,
  SecondBox,
  ThirdBox,
  Box,
  Typography,
} from "../styles";
import { getLanguageCode, defaultAllCode } from "../LanguageCode";
import DateRangePicker from "../../../components/DateRangePicker";
import { defaultAllCategory, getCategoryCode } from "../CategoryCode";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import dayjs from "dayjs";
import { useCookies, Cookies } from "react-cookie";
import moment from "moment";
import GradeIcon from "@mui/icons-material/Grade";

const Handler = () => {
  const {
    TemplatesStore: {
      gridOption: { page, rowsPerPage },
      application,
      setApplication,
      status,
      setStatus,
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      searchText,
      setSearchText,
      searchOption,
      setSearchOption,
      setLanguageChange,
      language,
      searchHandler,
      category,
      setCategoryChange,
      mixability,
      setMixability,
      reference,
      setReference,
      asset,
      setAsset,
      entertainment,
      setEntertainment,
      setRows,
      ratio,
      setRatio,
    },
  } = useStore();

  const [btnOpen, setBtnOpen] = useState(false);
  const [firstReviewerStatus, setFirstReviewerStatus] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies();
  const expires = moment().add("100", "y").toDate();
  const gGookies = new Cookies();
  const getCookie = (item: string) => {
    return gGookies.get(item);
  };

  const selectProps: SelectProps = {
    width: 122,
    name: "Status",
    value: status,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setStatus(event.target.value);
    },
    defaultValue: "InReview",
    list: [
      { label: "Preparing", value: "Preparing" },
      { label: "In Review", value: "InReview" },
      { label: "Rejected", value: "Rejected" },
      { label: "Published", value: "Published" },
      { label: "Blind", value: "Blind" },
      { label: "All", value: "All" },
    ],
  };

  const selectApplicationProps: SelectProps = {
    width: 122,
    name: "Application",
    value: application,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setApplication(event.target.value);
    },
    defaultValue: "all",
    list: [
      { label: "All", value: "all" },
      { label: "KineMaster", value: "kinemaster" },
      { label: "Spring", value: "spring" },
    ],
  };

  const selectRatioProps: SelectProps = {
    width: 175,
    name: "Ratio",
    value: ratio,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setRatio(event.target.value);
    },
    defaultValue: "all",
    list: [
      { label: "All", value: "all" },
      { label: "16:9", value: "16:9" },
      { label: "9:16", value: "9:16" },
      { label: "1:1", value: "1:1" },
      { label: "4:3", value: "4:3" },
      { label: "3:4", value: "3:4" },
      { label: "4:5", value: "4:5" },
      { label: "2.35:1", value: "2.35:1" },
    ],
  };

  const selectMixabilityProps: SelectRatingProps = {
    width: 155,
    name: "Mixability",
    value: mixability,
    defaultValue: 1,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setMixability(event.target.value);
    },
  };

  const selectReferenceProps: SelectRatingProps = {
    width: 155,
    name: "Reference",
    value: reference,
    defaultValue: 1,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setReference(event.target.value);
    },
  };

  const selectAssetProps: SelectRatingProps = {
    width: 155,
    name: "Asset",
    value: asset,
    defaultValue: 1,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setAsset(event.target.value);
    },
  };

  const selectEntertainmentProps: SelectRatingProps = {
    width: 155,
    name: "Entertainment",
    value: entertainment,
    defaultValue: 1,
    selectHandler: (event: SelectChangeEvent<any>) => {
      setEntertainment(event.target.value);
    },
  };

  const rangeDateProps = {
    startDate,
    endDate,
    setStartDate,
    setEndDate,
  };
  const onKeyPressEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      searchHandler();
    }
  };

  const searchProps: SearchProps = {
    option: {
      value: searchOption,
      selectHandler: (event: SelectChangeEvent<any>) => {
        setSearchOption(event.target.value);
        setSearchText("");
      },
      defaultValue: "templateId",
      list: [
        { label: "Template ID", value: "templateId" },
        { label: "Description", value: "description" },
        { label: "User ID", value: "userId" },
        { label: "User Name", value: "username" },
        // { label: "User Nickname", value: "name" },
        { label: "Reviewer", value: "reviewer" },
        { label: "First Reviewer", value: "firstReviewer" },
        { label: "Rejected Reason", value: "rejectedReason" },
        { label: "Extra Description", value: "extraDescription" },
        // { label: "Score", value: "score" },
        { label: "Dynamic Link", value: "dynamicLink" },
      ],
    },
    value: searchText,
    textHandler: (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchText(event.target.value);
    },
    removeHandler: () => {
      setSearchText("");
    },
    action: () => {
      searchHandler();
    },
    keyHandler: (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") searchHandler();
    },
  };
  const onChangeLang = (event: any, value: any) => {
    if (value) {
      // setAutoLangCode(value);

      setLanguageChange(value);
    }
  };

  const onChangeCategory = (event: any, value: any) => {
    if (value) {
      setCategoryChange(value);
    }
  };

  const handleButton = () => {
    setCookie("page", page, { path: "/", expires });
    setCookie("rowsPerPage", rowsPerPage, { path: "/", expires });
    setCookie("startDate", startDate, { path: "/", expires });
    setCookie("endDate", endDate, { path: "/", expires });
    setCookie("application", application, { path: "/", expires });
    setCookie("status", status, { path: "/", expires });
    setCookie("language", JSON.stringify(language), { path: "/", expires });
    setCookie("category", JSON.stringify(category), { path: "/", expires });
    setCookie("mixability", mixability, { path: "/", expires });
    setCookie("reference", reference, { path: "/", expires });
    setCookie("asset", asset, { path: "/", expires });
    setCookie("entertainment", entertainment, { path: "/", expires });
    setCookie("ratio", JSON.stringify(ratio), { path: "/", expires });

    setRows();
    setBtnOpen(false);
  };

  const handleClose = () => {
    setApplication(getCookie("application") ? getCookie("application") : "all");
    setStatus(getCookie("status") ? getCookie("status") : "InReview");

    setStartDate(
      window.location.pathname.includes("userid")
        ? dayjs("2023/01/01", "yyyy/MM/dd")
        : getCookie("startDate")
        ? getCookie("startDate")
        : dayjs().subtract(1, "month").toDate()
    );
    setEndDate(
      window.location.pathname.includes("userid")
        ? dayjs().toDate()
        : getCookie("endDate")
        ? dayjs(getCookie("endDate"), "yyyy/MM/dd").toDate()
        : dayjs().toDate()
    );

    setLanguageChange(
      getCookie("language") ? getCookie("language") : defaultAllCode
    );
    setCategoryChange(
      getCookie("category") ? getCookie("category") : defaultAllCategory
    );

    setMixability(
      getCookie("mixability")
        ? getCookie("mixability") === "0"
          ? 1
          : getCookie("mixability")
        : 1
    );
    setReference(
      getCookie("reference")
        ? getCookie("reference") === "0"
          ? 1
          : getCookie("reference")
        : 1
    );
    setAsset(
      getCookie("asset")
        ? getCookie("asset") === "0"
          ? 1
          : getCookie("asset")
        : 1
    );
    setEntertainment(
      getCookie("entertainment")
        ? getCookie("entertainment") === "0"
          ? 1
          : getCookie("entertainment")
        : 1
    );

    setRatio(getCookie("ratio") ? getCookie("ratio") : "all");

    setBtnOpen(false);
  };

  const handleFristReviewer = () => {
    setStatus("Published");
    setSearchOption("firstReviewer");
    setSearchText("auto.system@kinemaster.com");
    setRows();
    setBtnOpen(false);
    setFirstReviewerStatus(false);
  };

  return (
    <>
      <SecondContainer>
        <FilterAltIcon
          onClick={() => {
            setBtnOpen(true);
          }}
          sx={{ cursor: "pointer", color: "#6750a4" }}
        />
        <SecondBox
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <ThirdBox
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
              width: "100%",
              flexWrap: "wrap",
              pt: "10px",
            }}
          >
            <Typography sx={{ color: "#79747E" }}>Application</Typography>
            <Typography sx={{ width: "7%" }}>
              {application === "kinemaster"
                ? "KineMaster"
                : application === "spring"
                ? "Spring"
                : "All"}
            </Typography>
            <Typography sx={{ color: "#79747E" }}>Status</Typography>
            <Typography sx={{ width: "7%" }}>{status}</Typography>
            <Typography sx={{ color: "#79747E" }}>Date</Typography>
            <Typography sx={{ width: "18%" }}>
              {dayjs(startDate).format("YYYY-MM-DD") +
                " ~ " +
                dayjs(endDate).format("YYYY-MM-DD")}
            </Typography>
            <Typography sx={{ fontSize: "15px", color: "#79747E" }}>
              Language
            </Typography>
            <Typography
              sx={{
                width: "10%",
                maxWidth: "18%",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              {" "}
              {language.name}
            </Typography>
            <Typography sx={{ fontSize: "15px", color: "#79747E" }}>
              Category{" "}
            </Typography>
            <Typography
              sx={{
                pr: 5,
                width: "8%",
                maxWidth: "100px",
                whiteSpace: "nowrap",
              }}
            >
              {" "}
              {category.key}
            </Typography>
          </ThirdBox>
          <ThirdBox
            sx={{
              width: "940px",
              display: "flex",
              justifyContent: "flex-start",
              pt: "5px",
            }}
          >
            <Typography sx={{ fontSize: "15px", color: "#79747E" }}>
              Mixability
            </Typography>
            <Typography
              sx={{
                pr: 5,
                width: "18%",
                maxWidth: "100px",
                whiteSpace: "nowrap",
              }}
            >
              <span style={{ display: "flex" }}>
                {Array.from({ length: mixability }, (_, index) => (
                  <GradeIcon
                    key={index}
                    fontSize="small"
                    sx={{ color: "#faaf00" }}
                  />
                ))}
              </span>
            </Typography>

            <Typography sx={{ fontSize: "15px", color: "#79747E" }}>
              Reference
            </Typography>
            <Typography
              sx={{
                pr: 5,
                width: "18%",
                maxWidth: "100px",
                whiteSpace: "nowrap",
              }}
            >
              <span style={{ display: "flex" }}>
                {Array.from({ length: reference }, (_, index) => (
                  <GradeIcon
                    key={index}
                    fontSize="small"
                    sx={{ color: "#faaf00" }}
                  />
                ))}
              </span>
            </Typography>

            <Typography sx={{ fontSize: "15px", color: "#79747E" }}>
              Asset
            </Typography>
            <Typography
              sx={{
                pr: 5,
                width: "18%",
                maxWidth: "100px",
                whiteSpace: "nowrap",
              }}
            >
              <span style={{ display: "flex" }}>
                {Array.from({ length: asset }, (_, index) => (
                  <GradeIcon
                    key={index}
                    fontSize="small"
                    sx={{ color: "#faaf00" }}
                  />
                ))}
              </span>
            </Typography>

            <Typography sx={{ fontSize: "15px", color: "#79747E" }}>
              Entertainment
            </Typography>
            <Typography
              sx={{
                pr: 5,
                width: "18%",
                maxWidth: "100px",
                whiteSpace: "nowrap",
              }}
            >
              <span style={{ display: "flex" }}>
                {Array.from({ length: entertainment }, (_, index) => (
                  <GradeIcon
                    key={index}
                    fontSize="small"
                    sx={{ color: "#faaf00" }}
                  />
                ))}
              </span>
            </Typography>
            <Typography sx={{ fontSize: "15px", color: "#79747E" }}>
              Ratio
            </Typography>
            <Typography
              sx={{
                pr: 5,
                width: "18%",
                maxWidth: "100px",
                whiteSpace: "nowrap",
              }}
            >
              {ratio === "all" ? "All" : ratio}
            </Typography>
          </ThirdBox>
        </SecondBox>

        <SecondBox>
          <Search {...searchProps} />
        </SecondBox>
      </SecondContainer>

      <Dialog
        disableEscapeKeyDown
        open={btnOpen}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: "900px",
            minWidth: "900px",
            maxHeight: "650px",
            minHeight: "650px",
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Box>
            <Select {...selectApplicationProps} />
            <Select {...selectProps} />
            <Autocomplete
              disablePortal
              size="small"
              id="combo-box-demo"
              value={language}
              options={[defaultAllCode].concat(getLanguageCode)}
              onChange={onChangeLang}
              onKeyPress={onKeyPressEnter}
              getOptionLabel={(option: any) => {
                if (option.name === "All") {
                  return `All`;
                } else {
                  return `${option.name} (${option.value})`;
                }
              }}
              renderInput={(params) => {
                return <TextField {...params} label="Language" />;
              }}
              isOptionEqualToValue={(option: any, value: any) =>
                option.name === value.name && option.value === value.value
              }
              sx={{
                "& .MuiFormControl-root.MuiTextField-root": {
                  width: 240,
                  mr: "4px",
                },
              }}
            />
            <Autocomplete
              disablePortal
              size="small"
              id="combo-box-demo"
              value={category}
              options={[defaultAllCategory].concat(getCategoryCode)}
              onChange={onChangeCategory}
              onKeyPress={onKeyPressEnter}
              getOptionLabel={(option: any) => {
                if (option.key === "All") {
                  return `All`;
                } else {
                  return `${option.key}`;
                }
              }}
              renderInput={(params) => {
                return <TextField {...params} label="Category" />;
              }}
              isOptionEqualToValue={(option: any, value: any) =>
                option.key === value.key
              }
              sx={{
                "& .MuiFormControl-root.MuiTextField-root": {
                  width: 150,
                  mr: "4px",
                },
              }}
            />{" "}
            <FormControlLabel
              control={
                <Checkbox
                  checked={firstReviewerStatus}
                  onChange={(e) => setFirstReviewerStatus(e.target.checked)}
                />
              }
              label="Auto Publishing"
              sx={{ mr: 0 }}
            />
          </Box>

          <Box sx={{ pt: "10px", pb: "10px" }}>
            <SelectRationg {...selectMixabilityProps} />
            <SelectRationg {...selectReferenceProps} />
            <SelectRationg {...selectAssetProps} />
            <SelectRationg {...selectEntertainmentProps} />
            <Select {...selectRatioProps} />
          </Box>
          <DialogContent
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              pl: 0,
              pt: 1,
            }}
          >
            <DateRangePicker {...rangeDateProps} />
          </DialogContent>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleButton}>OK</Button>
        </DialogActions>

        <Dialog open={firstReviewerStatus} PaperProps={{ id: "openedDlg" }}>
          <DialogContent>
            <DialogContentText>
              Search is possible only in Publish status.
              <br /> Would you like to search it?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <Button onClick={() => setFirstReviewerStatus(false)}>No</Button>
              <Button onClick={handleFristReviewer}>Yes</Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Dialog>
    </>
  );
};

export default observer(Handler);
